import { XHRRequestCanceler } from '../../Libs/xhr/XHRRequestCanceler';
import { BaseApiDataResponse } from '../Models/ApiData';
import {
    VisiteMedicale,
    VisiteMedicaleDetailsApiDataResponse,
    VisiteMedicaleListOrder,
    VisiteMedicaleListResponse,
} from '../Models/VisiteMedicale/VisiteMedicale';
import { BaseDataService } from './Base/BaseDataService';

export const VisiteMedicaleEndpoints = {
    CREATE_VISITE_MEDICALE: '/api/v1/back/compagnons/visites_medicales',
    VISITE_MEDICALE: (visiteMedicaleId: string) =>
        `/api/v1/back/compagnons/visites_medicales/${visiteMedicaleId}`,
    VISITE_MEDICALES: '/api/v1/back/compagnons/visites_medicales',
    EXPORT_VISITE_MEDICALE_LIST: '/api/v1/back/compagnons/visites_medicales/export',
};

export interface IVisiteMedicaleDataService {
    createVisiteMedicale: (
        visiteMedicale: VisiteMedicale,
        cts: XHRRequestCanceler
    ) => Promise<VisiteMedicaleDetailsApiDataResponse>;

    getVisiteMedicale: (
        cts: XHRRequestCanceler,
        visiteMedicaleId: string
    ) => Promise<VisiteMedicaleDetailsApiDataResponse>;

    updateVisiteMedicale: (
        visiteMedicaleId: string,
        visiteMedicale: VisiteMedicale,
        cts: XHRRequestCanceler
    ) => Promise<VisiteMedicaleDetailsApiDataResponse>;

    deleteVisiteMedicale: (
        visiteMedicaleId: string,
        cts: XHRRequestCanceler
    ) => Promise<BaseApiDataResponse>;

    listVisiteMedicale: (
        params: {
            search?: string;
            order?: VisiteMedicaleListOrder;
        },
        cts: XHRRequestCanceler
    ) => Promise<VisiteMedicaleListResponse>;
}

class VisiteMedicaleDataService extends BaseDataService implements IVisiteMedicaleDataService {
    public createVisiteMedicale = (
        visiteMedicale: VisiteMedicale,
        cts: XHRRequestCanceler
    ): Promise<VisiteMedicaleDetailsApiDataResponse> => {
        const body = {
            compagnon_id: visiteMedicale.compagnon.compagnon_id,
            ...visiteMedicale,
        };
        return this.post(VisiteMedicaleEndpoints.CREATE_VISITE_MEDICALE, body, cts);
    };

    public getVisiteMedicale = (
        cts: XHRRequestCanceler,
        visiteMedicaleId: string
    ): Promise<VisiteMedicaleDetailsApiDataResponse> => {
        return this.get(VisiteMedicaleEndpoints.VISITE_MEDICALE(visiteMedicaleId), cts);
    };

    public updateVisiteMedicale = (
        visiteMedicaleId: string,
        visiteMedicale: VisiteMedicale,
        cts: XHRRequestCanceler
    ): Promise<VisiteMedicaleDetailsApiDataResponse> => {
        const body = {
            ...visiteMedicale,
        };
        return this.patch(VisiteMedicaleEndpoints.VISITE_MEDICALE(visiteMedicaleId), body, cts);
    };

    public deleteVisiteMedicale = (
        visiteMedicaleId: string,
        cts: XHRRequestCanceler
    ): Promise<BaseApiDataResponse> => {
        return this.delete(VisiteMedicaleEndpoints.VISITE_MEDICALE(visiteMedicaleId), cts);
    };

    public listVisiteMedicale = (
        params: { search?: string | undefined; order?: VisiteMedicaleListOrder | undefined },
        cts: XHRRequestCanceler
    ): Promise<VisiteMedicaleListResponse> => {
        return this.get(VisiteMedicaleEndpoints.VISITE_MEDICALES, cts, { params });
    };
}

const VisiteMedicaleDataServiceName = 'VisiteMedicaleDataService';
export { VisiteMedicaleDataService, VisiteMedicaleDataServiceName };
